<template>
  <div v-if="loading">

    <oil-cap
        :title="tableTitle"
        :buttons="capButtons"
        service-name="company"
        :search-filter="onSearchValueChange"
    />
    <v-divider class="my-2"/>

    <oil-table
        :hide-footer="true"
        :keys="tableKeys"
        :item-counts="companies.length+1"
        :items="companies"
        :paginate='count'
        @paginateAction='paginate'
        :rowClick="handleRowClick"
    >

      <template v-slot:IsActive="{value}">
        <v-chip class="ma-2" :color="value ? 'success' : ''" small>
          {{ value ? 'Активный' : 'Неактивный' }}
        </v-chip>
      </template>

      <template v-slot:CreatedAt="{value}">
        {{ value | date }}
        <br>
        <small class="grey--text">
          {{ value | time }}
        </small>
      </template>

    </oil-table>

  </div>
</template>

<script>
import {companiesService} from '@/services/CompaniesService'
import {tableKeys, tableButtons, tableTitle} from './setting/CompanyHelper.js'

export default {

  data: () => ({
    companies: [],
    tableTitle: tableTitle(),
    capButtons: tableButtons(),
    tableKeys: tableKeys(),
    count: {
      count: 0
    },
    loading: false
  }),
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
  },
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    this.loading = true
  },
  methods: {
    handleRowClick({Id}) {
      this.$router.push(`/company/${Id}`)
    },
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }
      this.companies = data
    },
    async paginate(page) {
      const response = await companiesService.paginate(page)
      const {count, dates} = response.data
      this.count.count = count
      this.companies = dates || []
    }
  }

}
</script>